<template>
  <div style="margin-bottom: 10px; text-align: left">
    <el-button type="primary" icon="el-icon-document" v-if="prentType == 'smallBag' && tableType == 'ToBeProcessed'"
      :disabled="selectedRows.length == 0" @click="toBatchReview">批量合理({{ selectedRows.length }})
    </el-button>
    <el-button type="primary" icon="el-icon-document" @click="exportExcel">导出</el-button>
    <el-button type="primary" @click="batchUpdata" :disabled="selectedRows.length < 1">批量更新申报信息<span v-if="selectedRows.length > 0">({{selectedRows.length}})</span></el-button>
    <el-button type="primary" @click="dialogVisible = true;audiReasonCode='';intForwarderConfigId=''" :disabled="selectedRows.length < 1" v-if="prentType=='smallBag' && (tableType == 'ToBeProcessed'|| tableType == 'warning')">批量更换货代公司</el-button>


    <el-dialog :visible="dialogVisible" @close="dialogVisible = false">
      <div slot="title" class="dialogTitle">批量更换货代公司</div>
      <!-- <h1>更换后需操作【批量审单】才会生效</h1> -->
      <el-form>
        <el-form-item label-width="150px">
          <div slot="label">
            <span style='color:red'>*</span>异常原因
          </div>
          <el-select v-model="audiReasonCode" placeholder="请选择">
            <el-option :label="item.value" :value="item.code" v-for="item in reasonList" :key="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="150px">
          <div slot="label">
            <span style='color:red'>*</span>建议货代公司
          </div>
          <el-select v-model="intForwarderConfigId" placeholder="请选择" @change="forwarderChange" filterable>
            <el-option :label="item.forwarder + '-' + item.shippingType" :value="item.intForwarderConfigId"
              v-for="item in forwarder" :key="item.intForwarderConfigId" style="max-width:500px"
              :title="item.forwarder + '-' + item.shippingType"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="intForwarderConfigId = '';audiReasonCode='', dialogVisible = false">取消</el-button>
        <!-- <el-button @click="$emit('batchSwitchForwarder',{...intForwarderConfig,audiReasonCode});dialogVisible=false" type="primary" :disabled="!intForwarderConfigId || !audiReasonCode">确定</el-button> -->
        <el-button @click="submit" type="primary" :disabled="!intForwarderConfigId || !audiReasonCode">确定并提交</el-button>
      </div>
    </el-dialog>
    <AbnormalDialog ref="abnormalDialogRef"/>
  </div>
</template>

<script>

import { batchReview, batchUpdateDeclarationInfo, exportDeliveryReview, getReviewForwarder, checkAbnormalDeliveryReviewApi } from "@/apis/outStock";
import { processingStatusList, deliveryTypes } from "../data";
import Calendar from "@/utils/calendar";
import store from "@/store";
import AbnormalDialog from "./abnormalDialog.vue";
export default {
  name: "InterBtnBox",
  components: {
    AbnormalDialog
  },
  data() {
    return {
      dialogVisible: false,
      audiReasonCode:'',
      intForwarderConfigId: '',
      intForwarderConfig:{}
    };
  },
  props: {
    selectedRows: {
      type: Array,
      required: true,
    },
    prentType: {
      type: String,
      required: true,
    },
    tableType: {
      type: String,
    },
    forwarder: {
      type: Array,
    },
    InterForm: {
      type: Object,
    },
    reasonList:{
      type: Array,
      default:()=>[]
    }
  },
  computed: {
  },
  methods: {
    toBatchReview() {
      this.$confirm("确认后选中订单将以合理的结果审核通过，货代公司不可用的订单将自动跳过不进行审核", "提示", {
        confirmButtonText: "确认",
        type: "warning",
        cancelButtonText: "取消",
      }).then(() => {
        console.log(this.selectedRows)
        let reviewFormList = this.selectedRows.map(item => {
          if(!!item.auditIntForwarderConfigId && !!item.auditIntShipConfigId && item.auditIntForwarderConfigId != '0'&& item.auditIntShipConfigId != '0'){
            return {
              "auditDistribution": item.auditDistribution,
              "auditIntShipConfigId": item.auditIntShipConfigId,
              "auditForwarder": item.auditForwarder,
              "auditIntForwarderConfigId": item.auditIntForwarderConfigId,
              "auditRemark": item.remark || '',
              "auditShippingType": item.auditShippingType,
              "deliveryReviewCode": item.deliveryReviewCode,
              version:item.version
            }
          }else{
            return {
              "auditDistribution":  item.distribution,
              "auditIntShipConfigId":  item.intShipConfigId,
              "auditForwarder": item.forwarder,
              "auditIntForwarderConfigId": item.intForwarderConfigId,
              "auditRemark": item.remark || '',
              "auditShippingType": item.shippingType,
              "deliveryReviewCode": item.deliveryReviewCode,
              version:item.version
            }
          }
        })

        batchReview(reviewFormList).then(({ code }) => {
          if (code === 0) {
            this.$message.success('成功')
            this.$emit('refeash')
          }
        });
      });
    },
    exportExcel() {
      let params = { ...this.InterForm.formInline }
      params.processingStatus = processingStatusList[this.tableType]
      params.deliveryType = deliveryTypes[this.prentType]
      if (this.selectedRows.length > 0) {
        let deliveryTaskCodeList = ''
        this.selectedRows.forEach((item,index)=>{
          deliveryTaskCodeList += item.deliveryTaskCode
          if(index < this.selectedRows.length - 1){
            deliveryTaskCodeList += ','
          }
        })
        params.deliveryTaskCodeList = deliveryTaskCodeList
      }
      exportDeliveryReview(params).then(res => {
        const date = Calendar.d1(Date.now());
        console.log(res)
        let blobObj = new Blob([res.data], { type: "application/octet-stream" });
        let blobUrl = window.URL.createObjectURL(blobObj);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = date + "国际发货审单.xls";
        link.click();
        window.URL.revokeObjectURL(link.href);
        if (res.status == 200) {
          this.$message.success("操作成功");
        }
      })
    },
    batchUpdata() {
      let params = this.selectedRows.map(item => {
        return item.deliveryReviewSpuList.map(itemLevel2 => {
          return itemLevel2.deliveryReviewDetailList.map(itemLevel3 => {
            return {
              deliveryReviewDetailId: itemLevel3.id,
              deliveryTaskCode: itemLevel3.deliveryTaskCode,
              productSku: itemLevel3.productSku
            }
          }).flat()
        }).flat()
      }).flat()
      batchUpdateDeclarationInfo(params).then(({ code, data }) => {
        if (code == 0) {
          this.$message.success('更新任务提交成功，请等待10-30秒后刷新页面')
        }
      })
    },
    forwarderChange(e) {
      if(this.selectedRows.some(v=>v.receivingNationCode != this.selectedRows[0].receivingNationCode)){
        this.$message.warning('不能同时勾选多个收货国家的单据')
        return false
      }
      this.intForwarderConfigId = ''
      this.intForwarderConfig = {}
      let params = {
        "auditIntForwarderConfigId": e,
        "deliveryType": {'FBA':0,'largeBag':1,'smallBag':2}[this.prentType],
        "systemSource": {'FBA':2,'largeBag':2,'smallBag':1}[this.prentType],
        "warehouse": store.getters.getWareCode,
        receivingNationCode: this.selectedRows[0].receivingNationCode
      }
      getReviewForwarder(params).then(({ code, data }) => {
        if(code == 0){
          this.intForwarderConfigId = e
          this.intForwarderConfig = data
        }else{
          this.intForwarderConfigId = ''
          this.intForwarderConfig = {}
        }
      })
    },
    async submit(){
      const checkData = await checkAbnormalDeliveryReviewApi({
        auditReasonCode: this.audiReasonCode,
        deliveryReviewCodeList: this.selectedRows.map((v) => v.deliveryReviewCode)
      })
      if(checkData.data.failNoList?.length > 0) {
        console.log(this.$refs.abnormalDialogRef)
        this.$refs.abnormalDialogRef.open(checkData.data.failNoList.map((v) => ({id: v})))
        return
      }
      this.$emit('toBatchEditAndSubmit',{
        ...this.intForwarderConfig,
        audiReasonCode: this.audiReasonCode
      });
      this.dialogVisible=false
    }
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  /* padding: 10px 20px 0; */
  padding: 0px 0px 0px 0px !important;
}

.dialogTitle{
  height: 60px;
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  background-color: #00284d;
  color: #e8e8e8;
}

</style>
